import React, { useMemo } from 'react'
import { View, StyleSheet, ViewStyle, Animated, Easing } from 'react-native'
import Svg, { Circle } from 'react-native-svg'

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large'
  status?: 'primary' | 'basic'
  style?: ViewStyle
}
export const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  status = 'primary',
  style,
}) => {
  const spinValue = useMemo(() => new Animated.Value(0), [])

  React.useEffect(() => {
    function startAnimation() {
      spinValue.setValue(0)
      Animated.timing(spinValue, {
        toValue: 1,
        duration: 1000,
        easing: Easing.linear,
        useNativeDriver: true,
      }).start(() => startAnimation())
    }

    startAnimation()

    return () => {
      spinValue.stopAnimation()
    }
  }, [spinValue])

  const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  })

  const sizeMap = {
    small: 16,
    medium: 30,
    large: 48,
  }

  const colorMap = {
    primary: '#00A0F3',
    basic: '#001929',
  }

  const spinnerSize = sizeMap[size]
  const spinnerColor = colorMap[status]

  return (
    <View style={[styles.container, style]}>
      <Animated.View style={{ transform: [{ rotate: spin }] }}>
        {/* eslint-disable-next-line i18next/no-literal-string*/}
        <Svg width={spinnerSize} height={spinnerSize} viewBox="0 0 50 50">
          <Circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke={spinnerColor}
            strokeWidth="5"
            // eslint-disable-next-line i18next/no-literal-string
            strokeLinecap="round"
            strokeDasharray="128"
            strokeDashoffset="82"
          />
        </Svg>
      </Animated.View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999999,
  },
})
